import type { PlsTechnicalData, PriceInformation, ProductGroup } from 'src/app/api/owcc/models';

export interface ProductData {
  vehicleId?: string;
  basePriceAmount?: number;
  totalOptionPriceAmount?: number;
  configurationPriceAmount?: number;
  discountablePriceAmount?: number;
  technicalData?: PlsTechnicalData;
  productGroup?: ProductGroup;
}

export interface PriceDisplayParams {
  footnoteContext?: string;
  isWithinModal?: boolean;
  darkMode?: boolean;
  useUILabel?: boolean;
  isLabelCenteredOnMQ1?: boolean;
  size?: string;
  force?: ForceData;
}

export interface ForceData {
  vehicleId?: string;
  technicalData?: PlsTechnicalData;
  price?: PriceInformation;
}

export interface PriceDisplayData {
  productData: ProductData;
  params: PriceDisplayParams;
}

export type ProductPriceResponseDto = unknown;

// https://pages.git.i.mercedes-benz.com/dh-io-pls/dcps-product-pricing/interfaces/FootnoteGroup.html
export type FootnoteGroup = unknown;

export enum PriceDisplayStatus {
  Error = 'error',
  Success = 'success',
  Deactivated = 'deactivated',
  // ℹ️ Unmount is not part of the original interface but added by us.
  Unmount = 'unmount'
}

// interface from https://pages.git.i.mercedes-benz.com/dh-io-pls/dcps-product-pricing/v3/components/pls-ui
export interface PriceDisplayEventData {
  priceData: ProductPriceResponseDto; // PLS Data
  footnotes: FootnoteGroup[];
  plsStatus: PriceDisplayStatus;
}
